import {Component} from '@angular/core';
import {MD_SLIDER_DIRECTIVES} from '@angular2-material/slider/slider';

@Component({
  moduleId: module.id,
  selector: 'slider-demo',
  templateUrl: 'slider-demo.html',
  directives: [MD_SLIDER_DIRECTIVES],
})
export class SliderDemo { }
